import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import ENDPOINT from "../../context/EndPoint";
import { useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

import topimg from "../../assets/images/invoiceimgs/top.png";
import bottomimg from "../../assets/images/invoiceimgs/bottom.png";
import logo from "../../assets/images/invoiceimgs/logo.png";
import stamp from "../../assets/images/invoiceimgs/stamp.png";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { Edit } from "@material-ui/icons";

const CreateInvoicePage = ({ profile }) => {

  const { student_id } = useParams();
  const [formData, setFormData] = useState({
    first_name: profile.first_name,
    last_name: profile.last_name,
    address: "",
    course_url: "",
    purchase_price: "",
  });

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const [open, setOpen] = useState(false);

  // Snackbar state
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });

  // Update Invoice Modal state
  const [updateOpen, setUpdateOpen] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [updateForm, setUpdateForm] = useState({
    id: '',
    purchase_id: '',
    purchase_datetime: '',
    first_name: '',
    last_name: '',
    address: '',
    course_url: '',
    purchase_price: '',
  });

  
  const [invoiceData, setInvoiceData] = useState({});
 

  const getInvoiceDetails = async () => {
    const formData = new FormData();
    formData.append("student_id", student_id);

    try {
      const response = await axios.post(
        ENDPOINT + "get-invoice-details.php",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (response.data && response.data.data) {
        setInvoiceData(response.data.data);
        // console.log(response.data);
      } else {
        setError("Error fetching invoice data.");
      }
    } catch (err) {
      console.error("Backend error:", err);
      setError("Unable to fetch data from the backend.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getInvoiceDetails();
  }, [student_id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const data = new FormData();
    data.append("first_name", formData.first_name);
    data.append("last_name", formData.last_name);
    data.append("address", formData.address);
    data.append("course_url", formData.course_url);
    data.append("purchase_price", formData.purchase_price);
    data.append("student_id", student_id);
    data.append("purchase_datetime", new Date().toISOString());

    try {
      const response = await axios.post(ENDPOINT + "create-invoice.php", data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data && response.data.invoice_id) {
        getInvoiceDetails(); // Refresh invoice list
    
      } else {
        setError("Failed to create invoice. Please try again.");
      }
    } catch (err) {
      console.error("Backend error:", err);
      setError("Unable to create invoice. Please check your connection.");
    } finally {
      setLoading(false);
    }
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // Open update modal and set form data
  const handleUpdateOpen = (invoice) => {
    setSelectedInvoice(invoice);
    setUpdateForm({
      id: invoice.id,
      purchase_id: invoice.purchase_id,
      purchase_datetime: invoice.purchase_datetime,
      first_name: invoice.first_name,
      last_name: invoice.last_name,
      address: invoice.address,
      course_url: invoice.course_url,
      purchase_price: invoice.purchase_price,
    });
    setUpdateOpen(true);
  };

  const handleUpdateClose = () => {
    setUpdateOpen(false);
    setSelectedInvoice(null);
  };

  // Handle update submit
  const handleUpdateSubmit = async (e) => {
    e.preventDefault();
    setUpdateLoading(true);
    try {
      const data = new FormData();
      Object.keys(updateForm).forEach((key) => {
        data.append(key, updateForm[key]);
      });

      const response = await axios.post(
        ENDPOINT + "update_invoice.php",
        data,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (response.data && response.data.status === "success") {
        setSnackbar({ open: true, message: "Invoice updated successfully.", severity: "success" });
        getInvoiceDetails();
        setUpdateOpen(false);
   
      } else {
        setSnackbar({ open: true, message: response.data.message || "Failed to update invoice.", severity: "error" });
      }
    } catch (err) {
      setSnackbar({ open: true, message: "Error updating invoice.", severity: "error" });
    } finally {
      setUpdateLoading(false);
    }
  };


  const deleteInvoice = async (id, purchase_id) => {
   
    try {
      const data = new FormData();
      data.append("id", id);
      data.append("purchase_id", purchase_id);

      const response = await axios.post(
        ENDPOINT + "delete_invoice.php",
        data,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (response.data && response.data.status === "success") {
        getInvoiceDetails();
        
               setSnackbar({ open: true, message: "Invoice deleted successfully.", severity: "success" });

      } else {
        setSnackbar({ open: true, message: response.data.message || "Failed to delete invoice.", severity: "error" });


      }
    } catch (err) {
   
      setSnackbar({ open: true, message: "Error deleting invoice.", severity: "error" });

    }
  };

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap">
        <div>
          <h1 className="">Invoice Management</h1>
          <p className="">Create and manage invoices for students</p>
        </div>
        <div>
          <Button variant="contained" color="primary" onClick={handleOpen}>
            Create Invoice
          </Button>
        </div>
      </div>

      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Create Invoice</DialogTitle>
        <DialogContent>
          {error && <div className="alert alert-danger">{error}</div>}
          <form id="create-invoice-form" onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="first_name" className="form-label">
                First Name
              </label>
              <input
                type="text"
                className="form-control"
                id="first_name"
                name="first_name"
                value={formData.first_name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="last_name" className="form-label">
                Last Name
              </label>
              <input
                type="text"
                className="form-control"
                id="last_name"
                name="last_name"
                value={formData.last_name}
                onChange={handleChange}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="address" className="form-label">
                Term
              </label>
              <input
                className="form-control"
                id="address"
                name="address"
                value={formData.address}
                onChange={handleChange}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="course_url" className="form-label">
                Course Name
              </label>
              <input
                type="text"
                className="form-control"
                id="course_url"
                name="course_url"
                value={formData.course_url}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="purchase_price" className="form-label">
                Purchase Price (₹)
              </label>
              <input
                type="number"
                className="form-control"
                id="purchase_price"
                name="purchase_price"
                value={formData.purchase_price}
                onChange={handleChange}
                min="0"
                step="0.01"
                required
              />
            </div>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            Cancel
          </Button>
          <Button
            type="submit"
            form="create-invoice-form"
            variant="contained"
            color="primary"
            disabled={loading}
          >
            {loading ? "Creating..." : "Create Invoice"}
          </Button>
        </DialogActions>
      </Dialog>

      <InvoicePage
        deleteInvoice={deleteInvoice}
        handleUpdateOpen={handleUpdateOpen}
        invoiceData={invoiceData}
        profile={profile}
        loading={loading}
        error={error}
      />

      {/* Update Invoice Modal */}
      <Dialog open={updateOpen} onClose={handleUpdateClose} maxWidth="sm" fullWidth>
        <DialogTitle>Update Invoice</DialogTitle>
        <DialogContent>
          <form id="update-invoice-form" onSubmit={handleUpdateSubmit}>
            <div className="mb-3">
              <label className="form-label">First Name</label>
              <input
                type="text"
                className="form-control"
                name="first_name"
                value={updateForm.first_name}
                onChange={e => setUpdateForm({ ...updateForm, first_name: e.target.value })}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Last Name</label>
              <input
                type="text"
                className="form-control"
                name="last_name"
                value={updateForm.last_name}
                onChange={e => setUpdateForm({ ...updateForm, last_name: e.target.value })}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Term</label>
              <input
                className="form-control"
                name="address"
                value={updateForm.address}
                onChange={e => setUpdateForm({ ...updateForm, address: e.target.value })}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Course Name</label>
              <input
                type="text"
                className="form-control"
                name="course_url"
                value={updateForm.course_url}
                onChange={e => setUpdateForm({ ...updateForm, course_url: e.target.value })}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Purchase Price (₹)</label>
              <input
                type="number"
                className="form-control"
                name="purchase_price"
                value={updateForm.purchase_price}
                onChange={e => setUpdateForm({ ...updateForm, purchase_price: e.target.value })}
                min="0"
                step="0.01"
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Purchase Date</label>
              <input
                type="datetime-local"
                className="form-control"
                name="purchase_datetime"
                value={updateForm.purchase_datetime ? updateForm.purchase_datetime.substring(0, 16) : ""}
                onChange={e => setUpdateForm({ ...updateForm, purchase_datetime: e.target.value })}
                required
              />
            </div>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleUpdateClose} color="secondary">
            Cancel
          </Button>
          <Button
            type="submit"
            form="update-invoice-form"
            variant="contained"
            color="primary"
            disabled={updateLoading}
          >
            {updateLoading ? "Updating..." : "Update Invoice"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for feedback */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </MuiAlert>
      </Snackbar>
    </>
  );
};

const InvoicePage = ({invoiceData, deleteInvoice, handleUpdateOpen,profile,loading,error }) => {
 

  const downloadPDF = () => {
    const input = document.getElementById("invoice-content");

    html2canvas(input, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      // Force the whole image to fit exactly into one A4 page
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

      pdf.save(`invoice_${profile.first_name+"_"+profile.last_name || "N/A"}.pdf`);
    });
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="d-flex justify-content-between flex-wrap">
      {Array.isArray(invoiceData) &&
        invoiceData.map((invoiceData) => (
          <div className="col-lg-6 col-12 p-2" key={invoiceData.purchase_id}>
            <div className="col-12 bg-white rounded shadow mx-auto m-2 p-3">
              <div id="invoice-content" className="w-100 p-3 border border-2 rounded-2">
                <div className="d-flex justify-content-end">
                  <img className="w-75" src={topimg} alt="Top decoration" />
                </div>

                <div className="w-100 top-section d-flex justify-content-between">
                  <div className="header1 w-50">
                    <img className="w-100" src={logo} alt="Company logo" />
                    <p className="m-2">www.skilluprise.com</p>
                  </div>
                  <div style={{ width: "30%" }} className="header2 text-start  p2">
                    <h3>INVOICE</h3>
                    <p className="mb-0 ">
                      INVOICE ID: {invoiceData.purchase_id || "N/A"}
                    </p>
                    <p>
                      Date:{" "}
                      {invoiceData.purchase_datetime
                        ? new Date(invoiceData.purchase_datetime).toLocaleDateString()
                        : "N/A"}
                    </p>
                  </div>
                </div>
                <hr />
                <div className="box border border-2 border-black d-flex justify-content-center justify-content-between col-12">
                  <div className="box1 w-50 p-3 m-2">
                    <h5>Company</h5>
                    <p>
                      Aweteck Services Pvt.Ltd 9-41-29/2, First Floor, Beside Bank of
                      India, MVP Sector 6, Visakhapatnam 530017
                    </p>
                  </div>
                  <div className="box2 w-50 p-3 m-2">
                    <h5>Customer</h5>
                    <p className=" mb-0">
                      {invoiceData.first_name || "N/A"} {invoiceData.last_name || ""}
                    </p>
                    {invoiceData.address ? (
                      <h6 className="d-flex mt-1">
                        {" "}
                        term : <h6 className="mb-0 pb-0 ms-2" > {invoiceData.address}</h6>
                      </h6>
                    ) : null}
                  </div>
                </div>

                <div className="container m-2 w-100 mt-5 d-flex justify-content-center">
                  <table className="table text-center">
                    <thead className="thead-light">
                      <tr>
                        <th>NO.</th>
                        <th>ITEM</th>
                        <th>PEOPLE</th>
                        <th>TOTAL</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="bg-secondary text-white">1</td>
                        <td className="bg-secondary text-white">
                          {invoiceData.course_url || "N/A"}
                        </td>
                        <td className="bg-secondary text-white">1</td>
                        <td className="bg-secondary text-white">
                          ₹{" "}
                          {invoiceData.purchase_price
                            ? (invoiceData.purchase_price - (invoiceData.purchase_price * 18) / 100).toFixed(2)
                            : "0.00"}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="d-flex justify-content-between w-100 flex-wrap">
                  <div className="mt-5 w-50">
                    <h3>Note:</h3>
                    <p>
                      We prioritize customer satisfaction. Our team is dedicated to
                      providing exceptional service and ensuring your safety.
                    </p>
                  </div>
                  <div className="w-50">
                    <div className="heds d-flex justify-content-between mt-5 p-2">
                      <div className="text-start">
                        <h6>Subtotal</h6>
                        <h6 className="mt-4">Tax(18%)</h6>
                      </div>
                      <div className="text-start">
                        <p>
                          ₹{" "}
                          {invoiceData.purchase_price
                            ? (invoiceData.purchase_price - (invoiceData.purchase_price * 18) / 100).toFixed(2)
                            : "0.00"}
                        </p>
                        <p className="mt-1">
                          ₹{" "}
                          {invoiceData.purchase_price
                            ? ((invoiceData.purchase_price * 18) / 100).toFixed(2)
                            : "0.00"}
                        </p>
                      </div>
                    </div>
                    <div className="totals bg-secondary text-white d-flex justify-content-between p-2">
                      <div className="text-end">
                        <h6 className="text-white" >TOTAL</h6>
                      </div>
                      <div className="text-start">
                        <h6 className="text-white">₹ {invoiceData.purchase_price ? invoiceData.purchase_price.toFixed(2) : "0.00"}</h6>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-center">
                  <img src={stamp} alt="Stamp" />
                </div>
                <div className="end text-center mb-3">
                  <p>Aweteck Services Pvt.Ltd</p>
                  <p>
                    9-41-29/2, First Floor, Beside Bank of India, MVP Sector 6,
                    Visakhapatnam, 530017
                  </p>
                  <p>Contact: +91-9490174876 | Email: contact@skillsuprise.com</p>
                </div>
                <img className="w-100" src={bottomimg} alt="Bottom decoration" />
              </div>
              <div className="d-flex justify-content-between mt-3 ms-3">
                <div className="w-50">
                  <button className="btn w-100 btn-primary" onClick={downloadPDF}>
                    Download
                  </button>
                </div>
              
            <div className="d-flex">      <Edit onClick={() => handleUpdateOpen(invoiceData)} className="text-success me-2"  />
               
                  <DeleteIcon className="text-danger" onClick={() => deleteInvoice(invoiceData.id, invoiceData.purchase_id)} type='submit' /></div>
              
              </div>
              <div className="d-flex justify-content-end mb-2">
               
              </div>
            </div>
          </div>
        ))}
    </div>
  );
};

export default CreateInvoicePage;